import OpticksSvgElement from "@/components/ui/OpticksSvgElement/OpticksSvgElement";
import type { OpticksSvgElementProps } from "@/components/ui/OpticksSvgElement/OpticksSvgElement.types";

// Collection: Tabler Icons
const ShieldCheckIcon = ({
  className,
  size = 16,
  "aria-label": ariaLabel,
}: OpticksSvgElementProps) => (
  <OpticksSvgElement
    className={`icon-shield-check${className ? ` ${className}` : ""}`}
    size={size}
    aria-label={ariaLabel}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path
      d="M8.12769 2.21907L8.13647 2.22591C9.61882 3.45713 11.4919 4.11825 13.4187 4.09016V4.09114L13.4294 4.09016L13.6023 4.0843C13.8876 5.08407 13.9753 6.13017 13.8562 7.16341C13.7346 8.2174 13.4017 9.23642 12.8787 10.1595C12.3556 11.0825 11.6519 11.8906 10.8103 12.5365C9.97436 13.1779 9.01883 13.6451 7.99976 13.9124C6.98089 13.6452 6.02505 13.1787 5.18921 12.5374C4.34745 11.8916 3.64398 11.0826 3.12085 10.1595C2.59771 9.23638 2.2649 8.21746 2.14331 7.16341C2.02413 6.13021 2.11099 5.08404 2.39624 4.0843C4.38461 4.15867 6.33125 3.49831 7.86304 2.22591L7.87183 2.21907L7.99878 2.1097L8.12769 2.21907ZM10.0007 5.24934C9.81456 5.24934 9.62974 5.28645 9.45776 5.35774C9.32884 5.41119 9.20879 5.48336 9.10132 5.57161L8.9978 5.66536L7.33276 7.32942L6.98511 6.98177L6.96753 6.96614L6.90503 6.91145L6.88647 6.89485L6.86792 6.8802L6.75757 6.80305C6.53111 6.65997 6.2686 6.58427 6.00073 6.5843L5.86694 6.59016C5.55351 6.62002 5.25985 6.7535 5.03198 6.96712L4.93823 7.0638C4.70021 7.33376 4.57373 7.68452 4.58472 8.04427C4.59577 8.4039 4.74382 8.74546 4.9978 9.00032L4.99878 9.0013L6.33179 10.3353L6.34839 10.3519L6.36597 10.3665L6.42847 10.4222L6.44604 10.4378L6.4646 10.4525C6.73717 10.6639 7.07832 10.769 7.42261 10.7474C7.76662 10.7257 8.0909 10.5789 8.33472 10.3353L11.0183 7.65169L11.0339 7.63411L11.0886 7.57161L11.1042 7.55403L11.1189 7.53548C11.304 7.29691 11.4074 7.00597 11.4158 6.70638L11.4138 6.57747L11.4001 6.45052C11.3548 6.15574 11.2172 5.88005 11.0027 5.66536C10.8711 5.53364 10.7147 5.42904 10.5427 5.35774C10.4137 5.30429 10.2779 5.26983 10.1394 5.25618L10.0007 5.24934Z"
      id="icon-stroke"
      strokeWidth="1.5"
    />
  </OpticksSvgElement>
);

export default ShieldCheckIcon;
